export const bordeauxPoolStandings = {
  women: {
    A: [
      { team: "New Zealand", played: 3, won: 3, lost: 0, points: 9 },
      { team: "France", played: 3, won: 2, lost: 1, points: 6 },
      { team: "Argentina", played: 3, won: 1, lost: 2, points: 3 },
      { team: "South Africa", played: 3, won: 0, lost: 3, points: 0 },
    ],

    B: [
      { team: "Australia", played: 3, won: 3, lost: 0, points: 9 },
      { team: "Japan", played: 3, won: 2, lost: 1, points: 6 },
      { team: "Fiji", played: 3, won: 1, lost: 2, points: 3 },
      { team: "Brazil", played: 3, won: 0, lost: 3, points: 0 },
    ],

    C: [
      { team: "USA", played: 3, won: 3, lost: 0, points: 9 },
      { team: "Canada", played: 3, won: 2, lost: 1, points: 6 },
      { team: "Spain", played: 3, won: 1, lost: 2, points: 3 },
      { team: "Great Britain", played: 3, won: 0, lost: 3, points: 0 },
    ],
  },

  men: {
    A: [
      { team: "Fiji", played: 3, won: 3, lost: 0, points: 9 },
      { team: "South Africa", played: 3, won: 2, lost: 1, points: 6 },
      { team: "Great Britain", played: 3, won: 1, lost: 2, points: 3 },
      { team: "Kenya", played: 3, won: 0, lost: 3, points: 0 },
    ],

    B: [
      { team: "USA", played: 3, won: 3, lost: 0, points: 9 },
      { team: "Australia", played: 3, won: 2, lost: 1, points: 6 },
      { team: "Spain", played: 3, won: 1, lost: 2, points: 3 },
      { team: "Uruguay", played: 3, won: 0, lost: 3, points: 0 },
    ],

    C: [
      { team: "New Zealand", played: 3, won: 3, lost: 0, points: 9 },
      { team: "France", played: 3, won: 2, lost: 1, points: 6 },
      { team: "Argentina", played: 3, won: 1, lost: 2, points: 3 },
      { team: "Germany", played: 3, won: 0, lost: 3, points: 0 },
    ],
  },
};